module.exports = __webpack_public_path__ + "assets/img/W3-5-F.43b8c468.png";